
import {NHVirtualForm} from '../../../../../utils/NHVirtualForm.js';
import {  message } from "antd";
let md5 = require("md5");

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
export const handle = (csxx,xsxx) => {
  
  let dsfzh=xsxx.DSFZH;  //请求第三方接口账户
  let key=csxx.key;//签名
  let tm=getNowFormatDate();
  let url=csxx.dddlljdz;//单点登录连接地址
 
  if(!url){
    message.info("支付路径不能为空，请联系管理员！");
    return;
  }
  if(!dsfzh){
    message.info("学号或考生号不能为空，请联系管理员！");
    return;
  }
  if(!key){
    message.info("参数不能为空，请联系管理员！");
    return;
  }
  console.log(dsfzh+tm+key)
    let sign=md5(dsfzh+tm+key);

  //虚拟表单提交
  let map={

    xh:dsfzh,
    tm:tm,
    sign:sign
  }
  console.log(map)
  NHVirtualForm(url,"_blank",map);


}



//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
var minutes = date.getMinutes(); //分
var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
  }
  var currentdate = year  + month  + strDate + hours + minutes + seconds;;
  return currentdate;
}



// WEBPACK FOOTER //
// ./app/pages/SelfHelp/pay/paydisc/payFxxy_tdtc_mmdl.js